import React from "react";
import './css/Holy.css';

const Holy = () => {
  return (
    <div className="omfg">
      <div style={{ backgroundColor: "#ffe98f", position: "relative", height: "100vh" }}>
        <div style={centerStyle}>
          <table
            width="380"
            height="300"
            cellSpacing="0"
            cellPadding="0"
            border="0"
          >
            <tbody>
              <tr>
                <td width="278">
                  <img src="./weezerleft.gif" alt="left section" />
                </td>
                <td width="29">
                  <img src="./weezermid.gif" alt="middle section" />
                </td>
                <td width="79">
                  <img src="./weezerright.gif" alt="right section" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const centerStyle = {
  margin: 0,
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  imageRendering: "crisp-edges",
};

export default Holy;
